import "./HomePage2.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Features from "./sections/Features";
import ImageGrid from "./sections/ImageGrid";
import Team from "./sections/Team";
import Footer from "@/reusable_sections/Footer";
export default function HomePage2() {
  return <div>
      <Header />
      <Hero />
      <Features />
      <ImageGrid />
      <Team />
      <Footer />
    </div>;
}